import { jsx as i } from "react/jsx-runtime";
import { Paper as p, Link as l, Group as r, Image as o } from "@ingeniorforeningen/figurine-core";
import { forwardRef as m } from "react";
import '../../../../assets/IconGridItem.css';const f = "_grid_16jgc_2", I = "_iconGridItem_16jgc_14", _ = "_link_16jgc_23", g = "_iconWrapper_16jgc_30", n = {
  grid: f,
  iconGridItem: I,
  link: _,
  iconWrapper: g
}, t = m((a, s) => {
  const { link: e, icon: c, ...d } = a;
  return /* @__PURE__ */ i(p, { ...d, p: 0, m: 0, className: n.iconGridItem, ref: s, children: e ? /* @__PURE__ */ i(l, { href: e?.href, target: e?.target, className: n.link, children: /* @__PURE__ */ i(r, { className: n.iconWrapper, children: /* @__PURE__ */ i(o, { ...c, caption: void 0, byline: void 0, fit: "contain", sizes: "92px" }) }) }) : /* @__PURE__ */ i(r, { className: n.link, children: /* @__PURE__ */ i(r, { className: n.iconWrapper, children: /* @__PURE__ */ i(o, { ...c, caption: void 0, byline: void 0, fit: "contain", sizes: "92px" }) }) }) });
});
t.displayName = "IconGridItem";
const u = t;
export {
  n as I,
  t as _IconGridItem,
  u as default
};
